import { useId, type ReactNode } from 'react';
import { Tooltip } from 'antd';

/**
 * G2b/K5 — kart ve blok notlari icin ⓘ. Kartta sayi + degisim (+ kar kartinda marj) kalir; "neyi kapsar"
 * aciklamasi buraya tasinir. Klavyeyle odaklanir (trigger hover+focus). Metin dugmenin icinde `hidden` span'de
 * de durur: `aria-describedby` ile ekran okuyucu "Açıklama" dugmesinde aciklamayi okur, testler metni ipucu
 * acmadan olcer. `normal-case`: KpiCard etiketi `uppercase`; "i" harfi buyumesin.
 */
export function Bilgi({ metin, testid }: { metin: ReactNode; testid: string }) {
  const id = useId();
  return (
    // `id`: rc-tooltip'in kendi `aria-describedby` enjeksiyonu ("developer passed id tek kaynaktir")
    // tetiklendiginde dugmenin `aria-describedby`'sini BIZIM id'imize esitler — asagidaki gizli span'la esler.
    <Tooltip title={metin} trigger={['hover', 'focus']} id={id}>
      <button
        type="button"
        aria-label="Açıklama"
        aria-describedby={id}
        data-testid={testid}
        className="focus-ring inline-grid place-items-center w-[18px] h-[18px] shrink-0 rounded-full border border-border bg-surface text-[11px] font-semibold normal-case tracking-normal leading-none text-ink-500 cursor-help"
      >
        <span aria-hidden="true">i</span>
        <span id={id} hidden>
          {metin}
        </span>
      </button>
    </Tooltip>
  );
}
